export const VERIFY_PIN_REQUEST_SENT = 'src/patientApp/ViewShareOutcomesRequest/VERIFY_PIN_REQUEST_SENT';
export const VERIFY_PIN_REQUEST_SUCCEED = 'src/patientApp/ViewShareOutcomesRequest/VERIFY_PIN_REQUEST_SUCCEED';
export const VERIFY_PIN_REQUEST_FAILED = 'src/patientApp/ViewShareOutcomesRequest/VERIFY_PIN_REQUEST_FAILED';

export const STATUSES = {
  PREPARED: 'sent',
  REQUESTED: 'submitted',
  INPROGESS: 'in_progress',
  FAILED: 'failed',
};
